import React, { useState } from 'react';
import cls from 'classnames';
import { AgreementMetadata, AgreementStatus } from '../../../models/AgreementMetadata';
import { Busy } from '../../core/busy';
import styles from './agreement_status.module.scss';
import { Agreement } from '../../../models/Agreement';
import Notification from '../../core/notification';

type Props = {
  className?: string;
  agreement: Agreement;
  meta: AgreementMetadata;
  prefix?: boolean;
  link?: boolean;
  offerUri: string;
}

/**
 * Renders an agreement's status.
 */
export const AgreementStatusIndicator: React.FC<Props> = ({
  className,
  agreement,
  meta,
  prefix = true,
  link = true,
  offerUri,
}) => {
  let translation = '';
  switch (meta?.status) {
    case AgreementStatus.Opened:
      translation = 'Öppnad';
      break;

    case AgreementStatus.Signed:
      translation = 'Signerad';
      break;

    case AgreementStatus.Canceled:
      translation = 'Återkallad';
      break;

    case AgreementStatus.Declined:
      translation = 'Avböjt';
      break;

    default:
    case AgreementStatus.Sent:
      translation = 'Skickad';
      break;
  }

  return (
    <div className={cls([styles.status, className])} data-status={meta?.status}>
      <div style={{ display: 'flex', flexDirection: 'row' }}>
        {prefix ? "Avtalstatus: " : null}
        {
          meta ? (
            translation
          ) : (<Busy />)
        }
      </div>

      {
        link ? (
          <div style={{display: "flex", flexDirection: "column"}}>
            <a href={offerUri} target="_blank" rel="noopener noreferrer" data-keep-popovers-open="yes">
              Öppna avtal (PDF)
            </a>
          </div>
        ) : null
      }
    </div>
  )
}